const keyboardDatePickerFormEquipServType = {
  invalidDateMessage: 'Data em formato inválido.',
  maxDateMessage: 'A data não pode exceder o limite.'
};

export default keyboardDatePickerFormEquipServType;
